import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "relative left-1/2 right-1/2 -mx-[50vw] w-screen" }
const _hoisted_2 = { class: "mx-auto w-full max-w-[1840px] px-10" }
const _hoisted_3 = { class: "mt-10" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm text-gray-500"
}
const _hoisted_6 = {
  key: 1,
  class: "text-sm text-red-600"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "grid gap-8 lg:grid-cols-[minmax(0,1fr)_300px]" }
const _hoisted_9 = { class: "space-y-6" }
const _hoisted_10 = { class: "rounded-xl border border-gray-200 bg-gray-50/60 p-4" }
const _hoisted_11 = { class: "mt-3 space-y-4" }
const _hoisted_12 = { class: "rounded-xl border border-gray-200 bg-gray-50/60 p-4" }
const _hoisted_13 = { class: "mt-3 space-y-4" }
const _hoisted_14 = { class: "rounded-xl border border-gray-200 bg-gray-50/60 p-4" }
const _hoisted_15 = { class: "mt-3 space-y-4" }
const _hoisted_16 = { class: "mt-6 flex items-center gap-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageBuilder = _resolveComponent("PageBuilder")!
  const _component_BlockEditor = _resolveComponent("BlockEditor")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[21] || (_cache[21] = _createElementVNode("div", { class: "mb-6" }, [
            _createElementVNode("h1", { class: "text-3xl font-semibold text-gray-900" }, " Edit Page "),
            _createElementVNode("p", { class: "text-sm text-gray-600 mt-1" }, " Update the website page content. ")
          ], -1)),
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Loading page... "))
            : (_ctx.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.error), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("form", {
                    onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.updatePage && _ctx.updatePage(...args)), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _createVNode(_component_PageBuilder, {
                          modelValue: _ctx.form.contentJson,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.contentJson) = $event)),
                          "selected-id": _ctx.selectedBlockId,
                          onSelect: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectedBlockId = $event))
                        }, null, 8, ["modelValue", "selected-id"])
                      ]),
                      _createElementVNode("aside", _hoisted_9, [
                        _createVNode(_component_BlockEditor, { block: _ctx.selectedBlock }, null, 8, ["block"]),
                        _createElementVNode("div", _hoisted_10, [
                          _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, " Page Info ", -1)),
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("div", null, [
                              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "block mb-2 text-xs font-medium text-gray-600" }, "Title", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.title) = $event)),
                                class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                                required: "",
                                type: "text"
                              }, null, 512), [
                                [_vModelText, _ctx.form.title]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _cache[10] || (_cache[10] = _createElementVNode("label", { class: "block mb-2 text-xs font-medium text-gray-600" }, "Slug", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.slug) = $event)),
                                class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                                required: "",
                                type: "text"
                              }, null, 512), [
                                [_vModelText, _ctx.form.slug]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _cache[11] || (_cache[11] = _createElementVNode("label", { class: "block mb-2 text-xs font-medium text-gray-600" }, "Summary", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.summary) = $event)),
                                class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                                rows: "3"
                              }, null, 512), [
                                [_vModelText, _ctx.form.summary]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_12, [
                          _cache[15] || (_cache[15] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, " Publishing ", -1)),
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("div", null, [
                              _cache[14] || (_cache[14] = _createElementVNode("label", { class: "block mb-2 text-xs font-medium text-gray-600" }, "Status", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.status) = $event)),
                                class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary"
                              }, _cache[13] || (_cache[13] = [
                                _createElementVNode("option", { value: "published" }, " Published ", -1),
                                _createElementVNode("option", { value: "draft" }, " Draft ", -1)
                              ]), 512), [
                                [_vModelSelect, _ctx.form.status]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-sm font-semibold text-gray-900" }, " SEO ", -1)),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", null, [
                              _cache[16] || (_cache[16] = _createElementVNode("label", { class: "block mb-2 text-xs font-medium text-gray-600" }, "SEO Title", -1)),
                              _withDirectives(_createElementVNode("input", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.seoTitle) = $event)),
                                class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                                type: "text"
                              }, null, 512), [
                                [_vModelText, _ctx.form.seoTitle]
                              ])
                            ]),
                            _createElementVNode("div", null, [
                              _cache[17] || (_cache[17] = _createElementVNode("label", { class: "block mb-2 text-xs font-medium text-gray-600" }, "SEO Description", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.seoDescription) = $event)),
                                class: "block w-full rounded-lg border border-gray-300 bg-white p-2.5 text-sm text-gray-900 focus:border-primary focus:ring-primary",
                                rows: "3"
                              }, null, 512), [
                                [_vModelText, _ctx.form.seoDescription]
                              ])
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _cache[20] || (_cache[20] = _createElementVNode("button", {
                        class: "inline-flex items-center rounded-lg bg-black px-5 py-2.5 text-sm font-semibold text-white hover:bg-gray-800",
                        type: "submit"
                      }, " Save Changes ", -1)),
                      _createVNode(_component_router_link, {
                        class: "text-sm font-medium text-gray-600 hover:text-gray-900",
                        to: "/administrator/pages"
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode(" Cancel ")
                        ])),
                        _: 1
                      })
                    ])
                  ], 32)
                ]))
        ])
      ])
    ])
  ]))
}